<!--
    课程分享-课时编辑-课件列表-右边表格数据
    作用：展示选中分类的课件列表数据
    说明：版本3.0
-->
<template>
  <div class="right-table">
    <div class="top">
      <div class="btns">
        <el-button
          size="medium"
          @click="$router.go(-1)">取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="handlerSubmit">提 交({{ allSelection.length }})</el-button>
      </div>
      <div class="filter">
        <el-input
          v-model="seachVal"
          style="width:300px"
          clearable
          placeholder="搜索名称"
          size="medium"
          @clear="handlerClear">
          <template slot="append">
            <el-button @click="handlerSearch">搜索</el-button>
          </template>
        </el-input>
      </div>
    </div>
    <el-table
      v-loading="isLoading"
      ref="table"
      :data="list"
      height="100%"
      class="table-demo"
      row-key="id"
      fit
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :reserve-selection="true"
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column
        v-for="(item,index) in tableHead"
        :key="index"
        :label="item.label"
        :width="item.width"
      >
        <template slot-scope="{row}">
          <span
            v-if="item.filterType"
            :style="item.filterColor&&item.filterColor[row[item.prop]]">{{ item.filterType[row[item.prop]] }}</span>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      class="pagination-demo"
      @current-change="handlerPage(listQuery.per_page)"
    />
  </div>
</template>
<script>
import { fetchCategoryCourse, updatePacketHours } from '@/api/courseOn';
import { tableHead } from './fields';
import { concat } from 'shelljs/commands';

export default {
  name: 'RightTable',
  props: {
    isAllSelection: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      nodeVal: null,
      seachVal: '',
      isLoading: false,
      tableHeight: window.innerHeight - 250, // table高度
      list: [],
      total: 0,
      listQuery: { // 列表请求参数
        page: 1,
        per_page: 15,
        'equal[result@clients_id]': this.$store.state.choicesSchool.id,
      },
      tableHead,
      isCheck: false, // 左侧当前节点是否选中
      pageCollection: [1], // 已点击的分页集合
      allSelection: [], // 表格选中项
    };
  },
  watch: {
    isAllSelection(val) {
      this.isCheck = val;
    },
    nodeVal() {
      this.pageCollection = [1];
    },
  },
  mounted() {
    window.onresize = () => {
      setTimeout(() => {
        this.tableHeight = window.innerHeight - 250;
      }, 10);
    };
  },
  methods: {
    // 获取课件数据
    getCourse(callback) {
      this.isLoading = true;
      this.listQuery['like[category@id]'] = this.nodeVal;
      fetchCategoryCourse(this.listQuery).then((res) => {
        this.list = res.items;
        this.total = res.meta.total;
        this.isLoading = false;
        callback && callback();
      });
    },
    // 搜索课件
    handlerSearch() {
      if (this.nodeVal) {
        this.listQuery['like[name]'] = this.seachVal;
        this.page = 1;
        this.getCourse();
      } else {
        this.$message.warning('请先选择学科！');
      }
    },
    handlerClear() {
      delete this.listQuery['like[name]'];
      this.page = 1;
      this.getCourse();
    },
    // 点击节点
    handlerNode(val) {
      if (this.nodeVal !== val) {
        this.listQuery.page = 1;
        this.nodeVal = val;
        this.getCourse();
      }
    },
    // 操作节点check
    // handlerCheckNode (val, state) {
    //   if (this.nodeVal !== val) {
    //     this.nodeVal = val
    //     this.getCourse(() => {
    //       this.selectionTable(state)
    //     })
    //   } else {
    //     this.selectionTable(state)
    //   }
    // },
    handlerCheckNode(val, state) {
      this.listQuery.page = 1;
      // this.allSelection = [];
      this.pageCollection = [1];
      this.nodeVal = val;
      this.getCourse(() => {
        this.selectionTable(state);
      });
    },
    // 点击分页
    handlerPage() {
      this.getCourse(() => {
        const page = this.listQuery.page;
        const isSate = this.pageCollection.includes(page);
        !isSate && this.selectionTable(this.isCheck);
        const allPages = [...this.pageCollection, page];
        this.pageCollection = [...new Set(allPages)];
        // console.log('this.pageCollection', this.pageCollection)
      });
    },
    selectionTable(val) {
      this.$nextTick(() => {
        this.list.forEach((row) => {
          this.$refs.table.toggleRowSelection(row, val);
        });
      });
    },
    // 表格check
    handleSelectionChange(val) {
      this.allSelection = val;
    },
    handlerSubmit() {
      if (!this.allSelection.length) {
        this.$message.warning('请选择课件！');
        return;
      }
      const initArr = []; // 初始已有课件
      const selArr = []; // 新增课件
      let resultArr = []; // 要提交课件
      const classHours = JSON.parse(sessionStorage.getItem('classHours'));
      classHours.forEach((item) => {
        initArr.push({
          result_id: item.result_id,
          detail_category_id: item.detail_category_id,
        });
      });
      this.allSelection.forEach((item) => {
        const filter = classHours.filter(v => item.id === v.result_id);
        if (!filter.length) {
          selArr.push({
            result_id: item.id,
            detail_category_id: 0,
          });
        }
      });
      const curId = this.$route.query.curId;
      if (curId) { // 修改
        let curIndex = null;
        const arr1 = [];
        const arr2 = [];
        initArr.forEach((item, index) => {
          if (item.result_id === +curId) {
            curIndex = index;
          }
        });
        initArr.forEach((item, index) => {
          if (index < curIndex) {
            arr1.push(item);
          } else if (index > curIndex) {
            arr2.push(item);
          }
        });
        resultArr = arr1.concat(selArr, arr2);
      } else { // 新增
        resultArr = initArr.concat(selArr);
      }
      const clientsId = this.$store.state.choicesSchool.id;
      const packetId = this.$route.query.packetId;
      const loading = this.$loading({
        lock: true,
        text: '数据提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      updatePacketHours(clientsId, packetId, resultArr).then((res) => {
        loading.close();
        if (res.status_code === 200) {
          this.$message.success('配置课时成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        loading.close();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.right-table{
  padding: 24px 0 24px 34px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .top{
    .btns, .filter{
      margin-bottom: 20px;
  }
  }
  .table-demo{
    height: calc(100%-250px);
  }
}
.pagination-demo{
  text-align: right;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/views/CourseOn/courseList/components/rightTable.vue